import { render, staticRenderFns } from "./AIPromptBox.vue?vue&type=template&id=7dd1f1bd&scoped=true"
import script from "./AIPromptBox.vue?vue&type=script&lang=js"
export * from "./AIPromptBox.vue?vue&type=script&lang=js"
import style0 from "./AIPromptBox.vue?vue&type=style&index=0&id=7dd1f1bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd1f1bd",
  null
  
)

export default component.exports